var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2400_13059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1F3048",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_13059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 24C21.25 24.95 21.2925 25.871 21.3715 26.75H28.6285C28.7075 25.871 28.75 24.95 28.75 24C28.75 23.05 28.7075 22.129 28.628 21.25H21.3725C21.2925 22.129 21.25 23.05 21.25 24ZM19.8665 21.25C19.7882 22.1646 19.7494 23.0821 19.75 24C19.75 24.943 19.79 25.8635 19.866 26.75H14.0885C13.8675 25.87 13.75 24.9485 13.75 24C13.75 23.0515 13.8675 22.13 14.0885 21.25H19.8665ZM21.5495 19.75H28.45C28.228 18.2365 27.892 16.887 27.4755 15.7785C27.086 14.742 26.641 13.9545 26.1855 13.4405C25.729 12.9245 25.326 12.75 25 12.75C24.674 12.75 24.271 12.925 23.814 13.44C23.3585 13.955 22.9135 14.742 22.524 15.7785C22.1075 16.887 21.7715 18.2365 21.549 19.75M30.1335 21.25C30.21 22.1365 30.25 23.057 30.25 24C30.25 24.943 30.21 25.8635 30.134 26.75H35.9115C36.1325 25.87 36.25 24.9485 36.25 24C36.25 23.0515 36.1325 22.13 35.9115 21.25H30.1335ZM35.42 19.75H29.9655C29.7305 18.056 29.3585 16.525 28.88 15.251C28.5745 14.438 28.2185 13.71 27.813 13.1045C31.273 13.9955 34.088 16.491 35.419 19.75M20.034 19.75H14.5805C15.911 16.491 18.7265 13.9955 22.1865 13.105C21.7815 13.71 21.425 14.438 21.1195 15.251C20.641 16.525 20.2695 18.056 20.0345 19.75M20.033 28.25H14.5805C15.9105 31.5075 18.7235 34.002 22.1805 34.894C21.7755 34.289 21.4205 33.561 21.1155 32.749C20.638 31.474 20.267 29.944 20.033 28.25ZM27.48 32.222C27.895 31.1135 28.23 29.764 28.452 28.25H21.548C21.7695 29.764 22.1045 31.1135 22.52 32.222C22.909 33.2585 23.3535 34.0455 23.81 34.5595C24.266 35.0745 24.67 35.25 25 35.25C25.33 35.25 25.734 35.0745 26.19 34.5595C26.6465 34.0455 27.091 33.2585 27.48 32.222ZM28.8845 32.7485C29.362 31.4745 29.733 29.9435 29.967 28.25H35.4195C34.0895 31.5075 31.2765 34.002 27.8195 34.894C28.2245 34.289 28.5795 33.5605 28.8845 32.7485Z",
    fill: "#F0F7FD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2400_13059",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2400_13059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2400_13059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_13059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/webIcon.d9805611ca8e87231d4cc00765485eb5.svg";
export { ForwardRef as ReactComponent };